// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Cover/cover.scss
// module id = 581
// module chunks = 0